import { useEffect, useState } from "react";
import "./Login.css";
import logoEmpresa from "../assets/logo_moroni2.png";
import API from "../api";

const Login = ({ onLogin }) => {
  const [Usuario, setUsuario] = useState("");
  const [ClaveAcceso, setPassword] = useState("");
  const [verPassword, setVerPassword] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const usuarioGuardado = localStorage.getItem("Usuario");
    const claveGuardada = localStorage.getItem("ClaveAcceso");
    if (usuarioGuardado) setUsuario(usuarioGuardado);
    if (claveGuardada) setPassword(claveGuardada);
  }, []);

  const manejarLogin = (e) => {
    e.preventDefault();

    fetch(`${API}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ Usuario, ClaveAcceso }),
    })

      .then((res) => {
        if (!res.ok) throw new Error("Login incorrecto");
        return res.json();
      })
      .then((data) => {
        localStorage.setItem("Usuario", Usuario);
        localStorage.setItem("ClaveAcceso", ClaveAcceso);
        localStorage.setItem("RolUsuario", data.rol);
        onLogin(data);
      })
      .catch(() => {
        setError("Usuario o contraseña incorrectos.");
      });
  };

  return (
    <div className="pantalla-dividida">
      <div className="lado-izquierdo">
        <img src="fondologin.jpg" alt="Imagen lateral" className="imagen-lateral" />
      </div>

      <div className="lado-derecho">
        <div className="login-box">
          <img src={logoEmpresa} alt="Logo Empresa" style={{ height: "140px", objectFit: "contain", backgroundColor: "transparent" }} />

          <form onSubmit={manejarLogin} className="w-100">
            <div className="mb-3">
              <label className="form-label">Usuario</label>
              <input
                type="text"
                value={Usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Ingrese su usuario"
                className="form-control"
                autoComplete="username"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Contraseña</label>
              <div className="input-group">
                <input
                  type={verPassword ? "text" : "password"}
                  value={ClaveAcceso}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Ingrese su contraseña"
                  className="form-control"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setVerPassword(!verPassword)}
                  className="btn btn-outline-secondary"
                >
                  {verPassword ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Iniciar sesión
            </button>
          </form>

          {error && (
            <div className="alert alert-danger mt-4 text-center">
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
